<template>
  <div class="improve">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="ImproveVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="450px"
      center
      @close="closeDialog"
    >
      <el-page-header @back="closeDialog"> </el-page-header>
      <div class="improveBox">
        <div class="title">{{ isReg ? "注册" : "完善资料" }}</div>
        <el-form
          ref="myform"
          :model="form"
          :rules="rules"
          label-width="96px"
          size="small"
          v-enterToNext="true"
        >
          <div
            v-if="isReg"
            style="padding: 20px; display: flex; justify-content: center"
          >
            <el-upload
              class="avatar-uploader"
              action=""
              accept=".jpg,.png"
              :show-file-list="false"
              :http-request="uploadAvatar"
            >
              <img
                :src="
                  form && form.selfImagePath
                    ? form.selfImagePath
                    : require('../../assets/img/avatar.png')
                "
                class="avatar"
              />
              <!-- <div class="hover-tip">上传头像</div> -->
            </el-upload>
          </div>
          <el-form-item label="姓名" prop="cname" v-if="isReg">
            <el-input v-model="form.cname" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex" v-if="isReg">
            <el-radio-group v-model="form.sex">
              <el-radio :label="'男'">男</el-radio>
              <el-radio :label="'女'">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="手机号码" prop="tel" v-if="isReg">
            <el-input v-model="form.tel" disabled maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码" prop="identityCard" v-if="isReg">
            <el-input v-model="form.identityCard" maxlength="18"></el-input>
          </el-form-item>
          <el-form-item label="是否园区" prop="isEnterPark">
            <el-radio-group
              v-model="form.isEnterPark"
              @change="$set(form, 'parkId', '')"
            >
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="园区名称" prop="parkId" v-if="form.isEnterPark">
            <el-select
              v-model="form.parkId"
              ref="select"
              placeholder="请选择园区"
              @change="parkChange"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推荐码" prop="refeCode" v-if="isReg">
            <el-input
              placeholder="如有邀请码，请填写邀请码"
              v-model="form.refeCode"
              maxlength="7"
            ></el-input>
          </el-form-item>
          <div style="text-align: center; margin-top: 40px">
            <el-button size="medium" type="primary" @click="save('myform')"
              >确 认</el-button
            >
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import IDCard from "china-id-card";
export default {
  //import引入组件才能使用
  components: {},
  props: {
    dialogTitle: null,
    visible: Boolean,
    bankInfoList: Array,
    companyList: null,
    isReg: {
      type: Boolean,
      default: false,
    },
    tel: null,
    userId: null,
  },
  data() {
    let validateIdcard = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码

      if (!value) {
        callback();
      }
      if (IDCard(value).isVerified != true) {
        callback(new Error("身份证号码不正确"));
      } else {
        callback();
      }
    };
    let validateRefeCode = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!value || value == undefined) {
        callback();
      }
      console.log(value);
      if (value.length != 7) {
        callback(new Error("请输入7位邀请码"));
      } else {
        callback();
      }
    };
    return {
      projectName: "",
      ImproveVisible: false,
      form: { isEnterPark: false, refeCode: "" },
      options: [],
      rules: {
        identityCard: [
          { required: true, message: "请输入身份证", trigger: "blur" },
          { validator: validateIdcard, trigger: "blur" },
        ],
        cname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        tel: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        refeCode: [
          { message: "请输入7位邀请码", trigger: "blur" },
          { validator: validateRefeCode, trigger: "blur" },
        ],
        parkId: [{ required: true, message: "请选择园区", trigger: "blur" }],
      },
    };
  },
  // 计算属性
  computed: {},
  // 监听data中的数据变化
  watch: {
    tel(value) {
      console.log(value);
      this.$set(this.form, "tel", this.tel);
    },
    visible(val) {
      this.ImproveVisible = val;
      if (val) {
        this.getParkManage();
      }
    },
  },
  // 生命周期：挂载完成时（可以访问DOM元素）
  mounted() {
    // this.getParkManage();
    console.log(this.companyList);
  },
  // 方法集合
  methods: {
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.$message.warning("填写信息有误，请检查表单");
          return;
        }
        if (this.isReg) {
          //注册
          this.register();
        } else {
          //完善资料
          this.CompanyEditCompanyInfo();
        }
      });
    },
    //完善公司信息
    CompanyEditCompanyInfo() {
      let sendData = {
        id: this.companyList[0].companyId,
        isEnterPark: this.form.isEnterPark,
      };
      this.$api.user.CompanyEditCompanyInfo(sendData).then((res) => {
        if (res.code === 0) {
          this.$emit("finish", 1);
          this.$message.success("完善成功！");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //注册
    register() {
      let sendData = {
        account: this.tel,
        tel: this.tel,
        cName: this.form.cname,
        selfImagePath: this.form.selfImagePath ? this.form.selfImagePath : "",
        password: "rayqee" + this.tel.slice(4, -1),
        repetitionPassword: "rayqee" + this.tel.slice(4, -1),
        refeCode: this.form.refeCode,
        sex: this.form.sex,
        isEnterPark: this.form.isEnterPark,
        parkId: this.form.isEnterPark ? this.form.parkId : "",
        parkName: this.form.isEnterPark ? this.parkName : "",
        identityCard: this.form.identityCard,
        userId: this.userId,
      };

      this.$api.user.RegisterIndividualAccount(sendData).then((res) => {
        if (res.code === 0) {
          this.$message.success("注册成功，请重新登录！");
          this.closeDialog();
          // setTimeout(() => {
          //   this.$emit("finish", 2);
          // }, 2000);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取园区列表
    getParkManage() {
      this.$api.parkManage.ParkList().then((res) => {
        if (res.code === 0) {
          this.options = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //选择园区
    parkChange(v) {
      this.options.forEach((item) => {
        if (item.id == v) {
          this.parkName = item.name;
        }
      });
      console.log(v);
    },
    closeDialog() {
      this.$emit("close");
    },
    // 上传透头像
    uploadAvatar(fileObj) {
      if (fileObj.file.size > 1024 * 1024 * 10) {
        this.$message.warning(
          "文件不符合规则（图片大小不超过 10M），请重新上传~"
        );
        return;
      }
      this.$api.upload
        .uploadSingleImage(fileObj.file)
        .then((res) => {
          if (res.code === 0) {
            this.form.selfImagePath = res.data[0];
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          this.submitLoading = false;
          if (error.response?.status == 400) {
            this.$message.warning("请上传jpg、png格式的图片");
            this.form.selfImagePath = "";
          }
        });
    },
  },
};
</script>
<style lang='less' >
.improve {
  .el-dialog__header {
    padding: 0;
  }
  .improveBox {
    .title {
      font-size: 22px;
      text-align: center;
      margin-top: 15px;
      margin-bottom: 15px;
    }
    .avatar-uploader {
      img {
        width: 55px;
        height: 55px;
        border-radius: 10px;
      }
    }
  }
}
</style>